import {defineRecipe} from '@chakra-ui/react'
export const linkTheme = defineRecipe({base: {color: 'blue.500'}})
